import { SettingModule } from "@/store/modules/settings.module";
import { toaster } from "@/utilities/toaster";
import { Machine, assign } from "xstate";
const twoFactorConfigMachine = Machine({
    id: "twoFactorConfigMachine",
    context: {
        passWordError: "",
        passCodeError: "",
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GET_TWO_FACTOR_CONFIG: { target: "checkTwoFactorAuthStatus" },
            },
        },
        checkTwoFactorAuthStatus: {
            tags: "showLoader",
            invoke: {
                src: () => SettingModule.CheckTwoFactorAuthIsEnabled(),
                onDone: [
                    { target: "twoFactorAuthEnabled", cond: () => SettingModule.twoFactorAuthStatus.isTwoFactorAuthEnabled },
                    { target: "twoFactorAuthDisabled", cond: () => !SettingModule.twoFactorAuthStatus.isTwoFactorAuthEnabled },
                ],
                onError: {
                    target: "serviceUnavailable",
                },
            },
        },
        twoFactorAuthDisabled: {
            tags: "showEnableUI",
            on: {
                ENABLE_TWO_FA: { target: "registerForTwoFactorAuth" },
            },
        },
        registerForTwoFactorAuth: {
            tags: "showTwoFactorConfigUI",
            initial: "idle",
            states: {
                idle: {
                    always: "gettingTwoFactorAuthConfiguration",
                },
                gettingTwoFactorAuthConfiguration: {
                    tags: "showLoader",
                    invoke: {
                        src: (context, event) => SettingModule.TwoFactorConfig(),
                        onDone: {
                            target: "loadedTwoFactorAuthConfiguration",
                            actions: ["showSuccessMessage"],
                        },
                        onError: {
                            target: "#twoFactorConfigMachine.serviceUnavailable",
                        },
                    },
                },
                loadedTwoFactorAuthConfiguration: {
                    initial: "idle",
                    states: {
                        idle: {
                            tags: "showTwoFactorVerifyUI",
                            on: {
                                VERIFYING_TWO_FACTOR: { target: "verifyTwoFactorAuthSetup" },
                            },
                        },
                        verifyTwoFactorAuthSetup: {
                            tags: "showTwoFactorVerifyUI",
                            invoke: {
                                src: (context, event) => SettingModule.VerifyTwoAuth(event.twoFactorAuth),
                                onDone: [
                                    {
                                        cond: (context, event) => !event.data.twoFactorAuthResult.isPassWordVerified && !event.data.twoFactorAuthResult.isAuthCodeVerified,
                                        target: "#twoFactorConfigMachine.registerForTwoFactorAuth.loadedTwoFactorAuthConfiguration.idle",
                                        actions: assign({
                                            passWordError: () => "Password is incorrect",
                                            passCodeError: () => "Authentication code is incorrect",
                                        }),
                                    },
                                    {
                                        cond: (context, event) => !event.data.twoFactorAuthResult.isPassWordVerified,
                                        target: "#twoFactorConfigMachine.registerForTwoFactorAuth.loadedTwoFactorAuthConfiguration.idle",
                                        actions: assign({
                                            passWordError: () => "Password is incorrect",
                                            passCodeError: () => "",
                                        }),
                                    },
                                    {
                                        cond: (context, event) => !event.data.twoFactorAuthResult.isAuthCodeVerified,
                                        target: "#twoFactorConfigMachine.registerForTwoFactorAuth.loadedTwoFactorAuthConfiguration.idle",
                                        actions: assign({
                                            passCodeError: () => "Authentication code is incorrect",
                                            passWordError: () => "",
                                        }),
                                    },
                                    {
                                        target: "gettingRecoveryCodes",
                                        actions: assign({
                                            passWordError: () => "",
                                            passCodeError: () => "",
                                        }),
                                    },
                                ],
                                onError: {
                                    target: "#twoFactorConfigMachine.registerForTwoFactorAuth.loadedTwoFactorAuthConfiguration.idle",
                                },
                            },
                        },
                        gettingRecoveryCodes: {
                            tags: "showLoader",
                            invoke: {
                                src: (context, event) => SettingModule.GettingRecoveryCodes(),
                                onDone: {
                                    target: "loadedRecoveryCodes",
                                },
                                onError: {
                                    target: "#twoFactorConfigMachine.registerForTwoFactorAuth.loadedTwoFactorAuthConfiguration.idle",
                                },
                            },
                        },
                        loadedRecoveryCodes: {
                            tags: "loadedRecoveryCodes",
                            on: {
                                SUCCESS_TWO_FA: { target: "#twoFactorConfigMachine.twoFactorAuthEnabled" },
                            },
                        },
                    },
                },
            },
        },
        twoFactorAuthEnabled: {
            tags: "showDisableUI",
            on: {
                MANAGE_TWO_FA: { target: "manageTwoFactorAuth" },
            },
        },
        manageTwoFactorAuth: {
            tags: ["manageTwoFactorAuthUI"],
            initial: "idle",
            states: {
                idle: {
                    on: {
                        DISABLE_TWO_FA: { target: "disablingTwoFactorAuth" },
                    },
                },
                disablingTwoFactorAuth: {
                    invoke: {
                        src: (context, event) => SettingModule.disableTwoFactorAuth(event.password),
                        onDone: [
                            {
                                cond: (context, event) => !event.data.twoFactorAuthResult.isPassWordVerified,
                                target: "#twoFactorConfigMachine.manageTwoFactorAuth.idle",
                                actions: assign({
                                    passWordError: () => "Password is incorrect",
                                }),
                            },
                            {
                                target: "#twoFactorConfigMachine.twoFactorAuthDisabled",
                                actions: assign({
                                    passWordError: () => "",
                                }),
                            },
                        ],
                        onError: {
                            target: "#twoFactorConfigMachine.manageTwoFactorAuth.idle",
                        },
                    },
                },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default twoFactorConfigMachine;
